import React from "react";
import currencyFormatter from "src/shared/util/currency-formatter";

type Props = {
  price: number | number[];
};

const PriceFormat = ({ price }: Props) => {
  // is range and start and end price is same
  if (Array.isArray(price) && price?.[0] !== price?.[1]) {
    return (
      <>
        {price.map((_price) => currencyFormatter().format(_price)).join(" - ")}
      </>
    );
  } else if (Array.isArray(price)) {
    return <>{currencyFormatter().format(price[0])}</>;
  } else {
    return <>{currencyFormatter().format(price)}</>;
  }
};
export default PriceFormat;
